import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const TYPE = {
  Safe: { bg: "#DCFCE7", color: "#166534" },
  Unsafe: { bg: "#FEE2E2", color: "#7F1D1D" },
  Environmental: { bg: "#DBEAFE", color: "#1E40AF" },
  Quality: { bg: "#FEF3C7", color: "#854D0E" },
};
const STATUS = {
  Open: { bg: "#FEF3C7", color: "#854D0E" },
  "In Progress": { bg: "#DBEAFE", color: "#1E40AF" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
};

export default function Observations() {
  const { data, siteNames } = useHSE();
  const settings = data.settings || {};
  const observationCategories = settings.obsCategories?.length ? settings.obsCategories : ["Housekeeping", "PPE", "Behavior", "Equipment", "Procedure"];
  const observationSubcategories = settings.observationSubcategories?.length ? settings.observationSubcategories : ["General"];
  const actionOwners = settings.actionOwners?.length ? settings.actionOwners : ["HSE Manager", "Operations Lead", "Maintenance Supervisor"];
  const mandateRecipients = settings.mandateRecipients?.length ? settings.mandateRecipients : ["HSE Manager", "Operations Lead", "Maintenance Supervisor"];
  const raised = data.observations.length;
  const closed = data.observations.filter((o) => o.status === "Closed").length;
  const open = data.observations.filter((o) => o.status === "Open").length;
  const sorOpen = data.observations.filter((o) => o.sorId && o.status === "Open").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Stat label="Raised" value={raised} />
      <Stat label="Closed" value={closed} tone="safe" />
      <Stat label="Open" value={open} tone="warning" />
      <Stat label="SOR Open" value={sorOpen} tone="critical" />
    </div>
  );

  return (
    <RegisterPage
      title="Leading Indicators"
      subtitle="MWT, HSSE meetings, toolbox meetings, safety talks, Speak Up, Perwira Safety, HOC cards and safety promotion"
      storeKey="observations"
      idPrefix="OBS"
      topPanels={Top}
      columns={[
        { key: "id", label: "Obs ID" },
        { key: "sorId", label: "SOR ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "department", label: "Dept" },
        { key: "type", label: "Type" },
        { key: "category", label: "Category" },
        { key: "subcategory", label: "Subcategory" },
        { key: "raisedBy", label: "Raised By" },
        { key: "responsible", label: "Responsible" },
        { key: "dueDate", label: "Due" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ type: TYPE, status: STATUS }}
      formFields={[
        { key: "id", label: "Observation ID" },
        { key: "sorId", label: "SOR ID (if applicable)" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "department", label: "Department", type: "select", options: data.settings.departments },
        { key: "type", label: "Observation Type", type: "select", options: ["Safe", "Unsafe", "Environmental", "Quality"] },
        { key: "category", label: "Observation Category", type: "select", options: observationCategories },
        { key: "subcategory", label: "Subcategory", type: "select", options: observationSubcategories },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "raisedBy", label: "Raised By", type: "select", options: actionOwners },
        { key: "responsible", label: "Responsible To", type: "select", options: mandateRecipients },
        { key: "dueDate", label: "Due Date", type: "date" },
        { key: "closureDate", label: "Closure Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      ]}
    />
  );
}

function Stat({ label, value, tone = "neutral" }) {
  const c = { safe: "#54A57B", warning: "#FFB517", critical: "#DC2626", neutral: "#183C55" }[tone];
  return (
    <div className="command-card p-3.5 border-l-4" style={{ borderLeftColor: c }}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{value}</div>
    </div>
  );
}
